import { footerColumns } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-6 md:py-14 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-alarm-warning-line text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">黑料51</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              黑料51吃瓜社区专注整理当下热点事件的时间线与公开线索，让每一位瓜友都能按顺序看懂来龙去脉，
              在讨论圈里把观点讲清楚。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-checkbox-circle-line text-xs" />
                </span>
                线索已核实
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-refresh-line text-xs" />
                </span>
                每 10 分钟更新
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            本站内容均由瓜友投稿与公开信息整理，仅供讨论参考，不构成任何事实认定或结论。如对内容有异议，可通过举报指引联系值班编辑处理。
          </p>
          <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">© 2026 黑料51 · 黑料51瓜田 · 保留所有权利</p>
            <div className="flex flex-wrap items-center gap-4">
              <a href="#top" className="whitespace-nowrap text-xs text-foreground-600 hover:text-primary-600">
                免责声明
              </a>
              <a href="#top" className="whitespace-nowrap text-xs text-foreground-600 hover:text-primary-600">
                隐私政策
              </a>
              <a href="#top" className="whitespace-nowrap text-xs text-foreground-600 hover:text-primary-600">
                站点地图
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}